import React, { useState } from 'react'
import { PoolFilterSelect, PoolFilterOption } from './styled'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeOrderBy, selectNft } from 'state/nft/slice'
import { OrderBy } from 'state/nft/types'
import { isBrowser } from 'react-device-detect'
import Switch from './Switch'
import { selectNftFavorites } from 'state/nftFavorites/slice'
import fetchNft from 'state/nft/actions/fetchNft'
import fetchFavoritedNft from 'state/nft/actions/fetchFavoritedNft'

function ChangeOrder() {
  const dispatch = useDispatch()
  const nft = useSelector(selectNft)
  const [orderBy, setOrderBy] = useState(nft.orderBy)
  const [orderByAs, setOrderByAs] = useState(nft.orderByAs)
  const [ready, setReady] = useState(false)
  const { favoriteMode } = useSelector(selectNftFavorites)

  useEffect(() => {
    if (!nft.isFirstTimeLoad && ready) {
      dispatch(changeOrderBy({ orderBy, orderByAs }))
      if (favoriteMode) {
        dispatch(fetchFavoritedNft())
      } else {
        dispatch(fetchNft())
      }
    }
    setReady(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, orderBy, orderByAs])

  return (
    <>
      <PoolFilterSelect name="sortBy" defaultValue={nft.orderBy} onChange={e => setOrderBy(e.target.value as OrderBy)}>
        <PoolFilterOption value="name">Name</PoolFilterOption>
        <PoolFilterOption value="stats.sevenDayVolume">Volume</PoolFilterOption>
        <PoolFilterOption value="stats.oneDayChange">24h %</PoolFilterOption>
        <PoolFilterOption value="stats.sevenDayChange">7d %</PoolFilterOption>
        <PoolFilterOption value="stats.marketCap">Market Cap</PoolFilterOption>
        <PoolFilterOption value="stats.floorPrice">Floor Price</PoolFilterOption>
        <PoolFilterOption value="stats.numOwners">Owners</PoolFilterOption>
        <PoolFilterOption value="stats.totalSupply">Assets</PoolFilterOption>
      </PoolFilterSelect>
      {isBrowser && (
        <Switch
          checked={orderByAs === 'desc'}
          onChange={() => setOrderByAs(prev => (prev === 'desc' ? 'asc' : 'desc'))}
        />
      )}
    </>
  )
}

export default ChangeOrder
